/* eslint-disable prettier/prettier */
import React from 'react'
import { Box, Typography, makeStyles} from '@material-ui/core';

const useStyles = makeStyles({
    message:{
        display:'flex',
        flexDirection:'column',
        marginTop:'20px',
        marginLeft:'10px',
        
    },
    own:{
        marginRight:'10px',
        alignItems:'flex-end'
    },
    messageTop:{

    },
    messageBottom:{
        fontSize:'12px',
        marginTop:'10px'
    },
    messageText:{
    padding:'10px',
    borderRadius:'20px',
    backgroundColor:'#f4bb44',
    color:'white',
    maxWidth:'300px',
    },
    ownText: {
        backgroundColor:'rgba(245,241,241)',
        color:'black',
    }
})

const Messge = ({own,message}) => {


  const classes = useStyles()
  return (
    <Box className={own?(`${classes.message} ${classes.own}`):(`${classes.message}`)}>
        <Box className={classes.messageTop}>
          <Typography className={own?(`${classes.messageText} ${classes.ownText}`):(`${classes.messageText}`)}>{message}</Typography>  
        </Box>
        <Box className={classes.messageBottom}>1 hour ago</Box>
    </Box>
  )
}

export default Messge